import React from 'react';
import { FormLabel } from '@chakra-ui/react';

import themeStyles from '../theme/styles';

const { form: { label: labelStyles }, textStyles: themeTextStyles } = themeStyles;

// NOTE: These are because the FormLabelStyles prop is currently broken as of Chakra >1.4
const Label = ({ textStyle, styles, as, children, ...props }) => {
  const textStyles = { ...themeTextStyles[textStyle], ...labelStyles, ...styles };
  return (
    <FormLabel as={as} {...textStyles} {...props}>
      {children}
    </FormLabel>
  );
};

export default Label;
